import React, { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLocation } from "react-router";
import BackBtn from "../../lib/BackBtn";

import { getExcelReport } from "../../../../api/user/userApi";

import { FileDownloader } from "../../lib";

import { Pie } from "react-chartjs-2";
import {
  getMatchReportWithoutPrice,
  downloadMatchReportWithoutPriceExcel,
} from "../../../../api/report/reportSpecialApi";

function SaleRportSpecial() {
  const navigate = useNavigate();
  let location = useLocation();
  const { state } = location as any;

  const goBack = () => navigate(-1);
  const {
    data: reportData,
    isLoading,
    refetch,
  } = useQuery(["user-report"], () => getMatchReportWithoutPrice(state), {
    enabled: false,
  });

  const { data: exportToExcel, refetch: exportToExcelRefetch } = useQuery(
    ["export-to-excel"],
    () => getExcelReport({ matchId: state }),
    {
      enabled: false,
    }
  );

  const [totalCapacity, setTotalCapacity] = useState<number>();
  const [totalPrice, setTotalPrice] = useState<number>();

  const [womenPlatformCapacity, setWomenPlatformCapacity] = useState<number>();
  const [womenPlatformPrice, setWomenPlatformPrice] = useState<number>();

  const [homeTeamCapacity, setHomeTeamCapacity] = useState<number>();
  const [homeTeamPrice, setHomeTeamPrice] = useState<number>();

  const [awayTeamCapacity, setAwayTeamCapacity] = useState<number>();
  const [awayTeamPrice, setAwayTeamPrice] = useState<number>();

  const [totalTickets, setTotalTickets] = useState<number>();
  const [totalTicketPrice, setTotalTicketPrice] = useState<number>();

  const [womenTickets, setWomenTickets] = useState<number>();
  const [womenTicketPrice, setWomenTicketPrice] = useState<number>();

  const [homeTeamTickets, setHomeTeamTickets] = useState<number>();
  const [homeTeamTicketPrice, setHomeTeamTicketPrice] = useState<number>();

  const [awayTeamTickets, setAwayTeamTickets] = useState<number>();
  const [awayTeamTicketPrice, setAwayTeamTicketPrice] = useState<number>();

  const [maleTickets, setMaleTickets] = useState<number>();

  const [totalUsedTickets, setTotalUsedTickets] = useState<number>();
  const [totalUsedTicketPrice, setTotalUsedTicketPrice] = useState<number>();

  const [womenUsedTickets, setWomenUsedTickets] = useState<number>();
  const [womenUsedTicketPrice, setWomenUsedTicketPrice] = useState<number>();

  const [homeTeamUsedTickets, setHomeTeamUsedTickets] = useState<number>();
  const [homeTeamUsedTicketPrice, setHomeTeamUsedTicketPrice] = useState<number>();

  const [awayTeamUsedTickets, setAwayTeamUsedTickets] = useState<number>();
  const [awayTeamUsedTicketPrice, setAwayTeamUsedTicketPrice] = useState<number>();

  const [homeTeamMale, setHomeTeamMale] = useState<number>(0);
  const [awayTeamMale, setAwayTeamMale] = useState<number>(0);
  const [homeTeamFemale, setHomeTeamFemale] = useState<number>(0);
  const [awayTeamFemale, setAwayTeamFemale] = useState<number>(0);

  const dataTicketCapacity = {
    labels: ["بانوان", "میزبان", "مهمان"],
    datasets: [
      {
        label: "ظرفیت بلیت‌ها",
        data: [
          womenPlatformCapacity || 0,
          homeTeamCapacity || 0,
          awayTeamCapacity || 0,
        ],
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"],
      },
    ],
  };

  const dataTicketSold = {
    labels: ["آقایان", "بانوان"],
    datasets: [
      {
        label: "بلیت های فروش رفته",
        data: [maleTickets || 0, womenTickets || 0],
        backgroundColor: ["#36A2EB", "#FF6384"],
        hoverBackgroundColor: ["#36A2EB", "#FF6384"],
      },
    ],
  };

  const dataTicketEntryToStadium = {
    labels: ["بانوان", "میزبان", "مهمان"],
    datasets: [
      {
        label: "بلیت های وارد شده به استادیوم ",
        data: [
          womenUsedTickets || 0,
          homeTeamUsedTickets || 0,
          awayTeamUsedTickets || 0,
        ],
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"],
      },
    ],
  };

  useEffect(() => {
    if (state) {
      refetch();
    }
  }, [state]);

  useEffect(() => {
    if (reportData) {
      setTotalPrice(reportData?.totalPrice);
      setTotalCapacity(reportData?.totalCapacity);
      setWomenPlatformCapacity(reportData?.womenPlatformCapacity);
      setWomenPlatformPrice(reportData?.womenPlatformPrice);
      setHomeTeamCapacity(reportData?.homeTeamCapacity);
      setHomeTeamPrice(reportData?.homeTeamPrice);
      setAwayTeamCapacity(reportData?.awayTeamCapacity);
      setAwayTeamPrice(reportData?.awayTeamPrice);

      setTotalTickets(reportData?.totalTickets);
      setTotalTicketPrice(reportData?.totalTicketPrice);
      setHomeTeamTickets(reportData?.homeTeamTickets);
      setHomeTeamPrice(reportData?.homeTeamPrice);
      setAwayTeamTickets(reportData?.awayTeamTickets);
      setAwayTeamTicketPrice(reportData?.awayTeamTicketPrice);
      setWomenTickets(reportData?.womenTickets);
      setWomenTicketPrice(reportData?.womenTicketPrice);

      setTotalUsedTickets(reportData?.totalUsedTickets);
      setTotalUsedTicketPrice(reportData?.totalUsedTicketPrice);
      setHomeTeamUsedTickets(reportData?.homeTeamUsedTickets);
      setHomeTeamUsedTicketPrice(reportData?.homeTeamUsedTicketPrice);
      setAwayTeamUsedTickets(reportData?.awayTeamUsedTickets);
      setAwayTeamUsedTicketPrice(reportData?.awayTeamUsedTicketPrice);
      setWomenUsedTickets(reportData?.womenUsedTickets);
      setWomenUsedTicketPrice(reportData?.womenUsedTicketPrice);
      setHomeTeamMale(reportData?.homeTeamMale);
      setAwayTeamMale(reportData?.awayTeamMale);
      setHomeTeamFemale(reportData?.homeTeamFemale);
      setAwayTeamFemale(reportData?.awayTeamFemale);
      setMaleTickets(reportData?.maleTickets);
    }
  }, [reportData]);

  return (
    <div className={"card"}>
      <div
        className={
          "card-title mt-5 mb-1 px-10 d-flex align-items-center justify-content-between "
        }
      >
        <h2>گزارش فروش</h2>
        <BackBtn onClick={goBack} />
      </div>
      <div className={"card-body"}>
        <div className="row">
          <div className="col-lg-12 mb-10">
            <div className="d-flex gap-5  align-items-center">
              <div>خروجی اکسل</div>
              <FileDownloader
                downloadFunc={() => downloadMatchReportWithoutPriceExcel(state)}
              />
            </div>
          </div>
        </div>
        <div className="row mt-20">
          <div className="col-lg-6">
            <div className={"row  "}>
              بلیت های فروش رفته
              <div className="d-flex mt-4 gap-2">
                <label>تعداد</label>
                <input
                  type="text"
                  className="form-control"
                  value={totalTickets?.toLocaleString()}
                />
              </div>
            </div>
            <div className={"row  mt-4"}>
            بلیت های فروش رفته اقایان 
            <div className="d-flex mt-4 gap-2">
                <label>تعداد</label>
                <input
                  type="text"
                  className="form-control"
                  value={maleTickets?.toLocaleString()}
                />
              </div>
            </div>

            <div className={"row  mt-4"}>
              بلیت های فروش رفته بانوان
              <div className="d-flex mt-4 gap-2">
                <label>تعداد</label>
                <input
                  type="text"
                  className="form-control"
                  value={womenTickets?.toLocaleString()}
                />
              </div>
            </div>

            <div className={"row  mt-4"}>
              بلیت های فروش رفته میزبان
              <div className="d-flex mt-4 gap-2">
                <label>تعداد</label>
                <input
                  type="text"
                  className="form-control"
                  value={homeTeamTickets?.toLocaleString()}
                />
              </div>
            </div>

            <div className={"row  mt-4"}>
              بلیت های فروش رفته اقایان میزبان
              <div className="d-flex mt-4 gap-2">
                <label>تعداد</label>
                <input
                  type="text"
                  className="form-control"
                  value={homeTeamMale?.toLocaleString()}
                />
              </div>
            </div>

            <div className={"row  mt-4"}>
              بلیت های فروش رفته بانوان میزبان
              <div className="d-flex mt-4 gap-2">
                <label>تعداد</label>
                <input
                  type="text"
                  className="form-control"
                  value={homeTeamFemale?.toLocaleString()}
                />
              </div>
            </div>

            <div className={"row  mt-4"}>
              بلیت های فروش رفته مهمان
              <div className="d-flex mt-4 gap-2">
                <label>تعداد</label>
                <input
                  type="text"
                  className="form-control"
                  value={awayTeamTickets?.toLocaleString()}
                />
              </div>
            </div>
            <div className={"row  mt-4"}>
              بلیت های فروش رفته اقایان مهمان
              <div className="d-flex mt-4 gap-2">
                <label>تعداد</label>
                <input
                  type="text"
                  className="form-control"
                  value={awayTeamMale?.toLocaleString()}
                />
              </div>
            <div className={"row  mt-4"}>
              بلیت های فروش رفته بانوان مهمان
              <div className="d-flex mt-4 gap-2">
                <label>تعداد</label>
                <input
                  type="text"
                  className="form-control"
                  value={awayTeamFemale?.toLocaleString()}
                />
              </div>
            </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className={"row  mt-4"}>
              <h4>نمودار بلیت‌های فروش رفته</h4>
              <Pie data={dataTicketSold} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SaleRportSpecial;
